function initScrollingMessages() {
    const messagesContainer = $('.header-message .messages-container');
    let messageContainerWidth = 0;
    messagesContainer.find('.message').each((i, el) => {
        messageContainerWidth += $(el).innerWidth()+50;
    });
    const headerMessageWidth = messagesContainer.parent().width();
    const transitionSecond = (messageContainerWidth+headerMessageWidth)/100;

    messagesContainer.css({
        'transform': `translateX(-${messageContainerWidth}px)`,
        'transition': `transform ${transitionSecond}s linear`,
        '-webkit-transition': `transform ${transitionSecond}s linear`
    });
    setTimeout(() => $('.header-message .messages-container').attr('style', ''), transitionSecond*1000);
    setTimeout(initScrollingMessages, transitionSecond*1000+1);
}

export default initScrollingMessages;